export const popoverTheme = {
    borderColor: (props) => props.theme.palette.errorAlt,
    byMaxWidth: {
        sm: { maxWidth: '100px' },
        md: { maxWidth: '300px' },
        lg: { maxWidth: '400px' },
        xl: { maxWidth: '600px' },
        none: { maxWidth: 'none' },
    },
    byMinWidth: {
        sm: { minWidth: '100px' },
        md: { minWidth: '200px' },
        lg: { minWidth: '300px' },
        xl: { minWidth: '500px' },
        none: { minWidth: 'none' },
    },
    transition: {
        duration: '200ms',
    },
};
export const popoverMinWidthVariant = (props) => popoverTheme.byMinWidth[props.minWidth ?? 'none'];
export const popoverMaxWidthVariant = (props) => popoverTheme.byMaxWidth[props.maxWidth ?? 'none'];
